<template>
  <div class="of-box of-tabs" style="border-radius: 0px;">
    <div class="of-container is-vertical" style="border-radius: 0px;">
      <div class="of-aside of-tabs-bar tabs-byleft" style="padding:0px">
        <div class="clear-both" style="padding:0px">
          <ul class="newTab">
            <li :class="tabIndex==index?'tabActive':''" v-for="(item, index) in tabsList"
              :key="index" @click="tabsActive = item.name,tabIndex=index">{{item.label}}</li>
            <li class="newTabIcon"></li>
          </ul>
        </div>
      </div>
      <div class="of-main smake-box">
        <component :is="tabsActive" :node="node"></component>
      </div>
    </div>
  </div>
</template>

<script>
import slist from './service'
import cModelList from '@/modules/contract/pages/freightnew/cmodel/list'
import dModelList from '@/modules/contract/pages/freightnew/dmodel/list'
import yfList from '@/modules/timp/pages/yfconfig/list.vue'

export default {
  name: 'FreightReportMake2',
  components: {
    slist,
    cModelList,
    dModelList,
    yfList
  },
  props: {
    node: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      tabsActive: 'slist',
      tabIndex: 0,
      tabsList: [
        {
          name: 'slist',
          label: '合同列表'
        },
        {
          name: 'dModelList',
          label: '运单筛选规则'
        },
        {
          name: 'cModelList',
          label: '多条件计价规则配置'
        },
        {
          name: 'yfList',
          label: '单一路线计价规则配置'
        },
      ]
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.newTab {
  display: flex;
  background: #f2f3f5;
  li {
    padding: 13px 23px;
    border-radius: 0px;
    cursor: pointer;
    border-bottom: 1px solid #e4e7ed;
    &:first-child {
      border-left: 0px;
    }
  }
  .tabActive {
    background: #fff;
    color: #2d4a98;
    border-bottom: 0px;
    border-right: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    //  border-top: 4px solid #2D4A98;
    position: relative;

    &::after {
      content: '';
      height: 4px;
      width: 100.8%;
      top: 0;
      left: 0;
      position: absolute;
      background-color: #2d4a98;
    }
  }
  .newTabIcon {
    flex: 1;
    cursor: inherit;
    border-bottom: 1px solid #e4e7ed;
  }
}
.tabs-byleft::after {
  content: none !important;
}
</style>

<style>
.btns {
  text-align: right;
  width: 100%;
}
.smake-box .of-listbox .listbox-main .of-container {
  padding: 0 !important;
  border: unset !important;
}
.smake-box .of-box {
  padding: 0 !important;
  border: unset !important;
}
</style>
